import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import SyncIcon from '@mui/icons-material/Sync';
import {Badge} from '@mui/material';
import ModalCustom from "@ui/modal/ModalCustom";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import SyncVoyagesVoyageTemplate from "@containers/singleVoyage/voyageTemplates/sync/SyncVoyagesVoyageTemplate";
import {HEADER_SYNC} from "@containers/singleVoyage/voyageTemplates/sync/theme";

const badgeSx = {
	'& .MuiBadge-badge': {
		height: '15px',
		minWidth: '15px',
		px: '3px',
		fontSize: '10px',
		// table rows are low: hang off the side of the icon, not below it
		transform: 'scale(1) translate(40%, 0%)',
	},
}

interface IProps {
	templateId: number
	accountId: string | number
	button?: ReactElement
	initialOpen?: boolean
	onClose?: () => void
	/** voyages that differ from the template, shown on the default button */
	outdatedCount?: number
}

const SyncVoyagesVoyageTemplateModal = ({templateId, accountId, button, initialOpen, onClose, outdatedCount}: IProps) => {

	const {t} = useTranslation()

	return (
		<ModalCustom
			label={t('singleVoyage.voyageTemplate.sync.title')}
			initialFullScreenMode={false}
			headerSx={HEADER_SYNC}
			initialOpen={initialOpen}
			onClose={onClose}
			component={<SyncVoyagesVoyageTemplate
				templateId={templateId}
				accountId={accountId}
			/>}
			button={button ?? <IconButtonCustom
                variant={'empty'}
                tooltip={outdatedCount
					? t('singleVoyage.voyageTemplate.sync.outdatedCount', {count: outdatedCount})
					: t('singleVoyage.voyageTemplate.sync.open')}
            >
                <Badge
                    badgeContent={outdatedCount}
                    color={'error'}
                    max={99}
                    // bottom corner keeps it inside its own table row
                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                    sx={badgeSx}
                >
                    <SyncIcon/>
                </Badge>
            </IconButtonCustom>}
		/>
	);
};

export default SyncVoyagesVoyageTemplateModal;
